import { render, staticRenderFns } from "./FlagAt.vue?vue&type=template&id=27131d1c&"
import script from "./FlagAt.vue?vue&type=script&lang=js&"
export * from "./FlagAt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports